import { Section } from 'components/Section';
import { CategoryLink } from 'components/Shared/CategoryLink';
import { Grid, Cell } from 'components/Grid';
import { NO_ELEMENT } from 'utils';
import { Ad } from 'components/Ad';
import styles from './categoryCollection.scss';
import { Appearances } from 'models/SectionBlock';
import { isMobile, isTablet, isHuge } from 'components/Shared/responsive';
import { PageState } from 'models/PageState';
import connect from 'components/Shared/connect';
import { CategoryCollectionBlock } from 'models/CategoryCollectionBlock';
import cn from 'classnames';

const getAppearance = (sizes: { isMobile: boolean; isTablet: boolean; isHuge: boolean }) => {
  if (sizes.isMobile) {
    return 'tertiary';
  }
  if (sizes.isTablet) {
    return 'quarternary';
  }
  if (sizes.isHuge) {
    return 'primary';
  }
  return 'secondary';
};

const _CategoryCollection = ({
  title,
  categories,
  isMobile,
  isTablet,
  isHuge,
  theme,
  ad
}: MergedProps) => {
  if (!categories) {
    return NO_ELEMENT;
  }

  const appearance = getAppearance({ isMobile, isTablet, isHuge });

  const AMOUNT_OF_ITEMS_LARGE = 4;
  const AMOUNT_OF_ITEMS_SMALL = 3;
  const amountOfItems = isMobile ? AMOUNT_OF_ITEMS_SMALL : AMOUNT_OF_ITEMS_LARGE;

  const categoryLinks = categories.slice(0, amountOfItems).map(({ title, image, url }) => (
    <Cell key={url}>
      <CategoryLink categoryUrl={url} appearance={appearance} title={title} image={image} />
    </Cell>
  ));

  return (
    <Section
      title={title}
      appearance={Appearances.Secondary}
      full={isMobile}
      theme={{ surface: theme && theme.surface, onSurface: theme && theme.onSurface }}
      className={cn({ [styles.sectionPadding]: !isHuge && !isMobile })}
    >
      <Grid
        tablet="2"
        phone="1"
        gutters={isHuge ? 'extraLarge' : 'hidden'}
        className={styles.surfacePadding}
      >
        <Cell>
          <Grid
            className={cn(styles.surfaceMargin, styles.alignCells)}
            huge="4"
            large="2"
            tablet="2"
            phone="3"
          >
            {categoryLinks}
          </Grid>
        </Cell>
        <Cell>
          <Ad className={styles.adHeight} onSurface={theme && theme.onSurface} ad={ad} />
        </Cell>
      </Grid>
    </Section>
  );
};

interface MergedProps extends CategoryCollectionBlock {
  isMobile: boolean;
  isTablet: boolean;
  isHuge: boolean;
  title: string;
}

export const CategoryCollection = connect<MergedProps, CategoryCollectionBlock>(
  ({ currentBreakpoint }: PageState) => ({
    isMobile: isMobile({ currentBreakpoint }),
    isTablet: isTablet({ currentBreakpoint }),
    isHuge: isHuge({ currentBreakpoint })
  })
)(_CategoryCollection);
